module.exports = __webpack_public_path__ + "img/tarj2-1.0f1eee1c.png";